import React from 'react';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import { withRouter } from 'react-router';
import { blue600 } from 'material-ui/styles/colors';

const styles = {
  link: {
    cursor: 'pointer',
    color: blue600,
  },
};

// $FlowFixMe
const renderTableRow = ([key, { value, handleClick }]) => (
  <TableRow key={key}>
    <TableRowColumn>{key}</TableRowColumn>
    <TableRowColumn onClick={handleClick}>
      <div style={styles.link}>{value}</div>
    </TableRowColumn>
  </TableRow>
);

const ActivityGrid = ({ metrics, history }) => {
  const data = {
    'Open Job Requests': {
      value: metrics.openJobOffers,
      handleClick: () => {
        history.push('');
      },
    },
    'Open Job Requests (No Offers)': {
      value: metrics.openJobRequestsWithNoOffers,
      handleClick: () => {
        history.push();
      },
    },
    'Started Jobs': {
      value: metrics.startedJobs,
      handleClick: () => {
        history.push();
      },
    },
    'Pending Tutors': {
      value: metrics.pendingTutors,
      handleClick: () => {
        history.push();
      },
    },
    'Open Job Offers': {
      value: metrics.openJobOffers,
      handleClick: () => {
        history.push();
      },
    },
  };

  return (
    <Table selectable={false} multiSelectable={false}>
      <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
        <TableRow>
          <TableHeaderColumn>Metric</TableHeaderColumn>
          <TableHeaderColumn>Count</TableHeaderColumn>
        </TableRow>
      </TableHeader>
      <TableBody displayRowCheckbox={false}>
        {Object.entries(data).map(renderTableRow)}
      </TableBody>
    </Table>
  );
};

export default withRouter(ActivityGrid);



// WEBPACK FOOTER //
// ./src/components/home/activity/ActivityGrid.js